export const titleTypes: Record<string, string> = {
    "customer_first": "Customer first - Stellantis",
    "hway": "H-Way - Hyundai",
    "mysales": "My Sales",
}
export const urlLogoTypes: Record<string, string> = {
    "STELLANTIS": "https://companieslogo.com/img/orig/STLA-7ff80a99.png?t=1634834340",
    "HYUNDAI": "https://companieslogo.com/img/orig/HYMTF-f0fcea48.png?t=1634834834",
    "KIA": "https://companieslogo.com/img/orig/000270.KS-3c80d4c1.png",
}


